module.exports = __webpack_public_path__ + "img/Coupon-lw.561cdd0b.png";